import type {SearchCriteria} from '../types';
import {searchCriteriaToSmallSALO} from './searchCriteriaToSmallSALO';

/**
 * Enocde search criteria to base64 and uri encode
 * @param criteria
 * @returns uri encoded base64 search criteria
 */
export const encodeBase64Rules = (criteria: SearchCriteria) => {
	return encodeURIComponent(
		Buffer.from(
			JSON.stringify(searchCriteriaToSmallSALO(criteria)),
			'utf8',
		).toString('base64'),
	);
};

export default encodeBase64Rules;
